import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { forgotPassword, clearAuthError } from 'store/slices/authSlice';
import AuthPage from 'components/layout/AuthPage/AuthPage';
import { EmailField } from 'components/forms';
import { PrimaryButton, Link } from 'components/buttons/';

function Forgot() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  const { register, handleSubmit, formState: { errors, isDirty } } = useForm({ mode: "onChange" });

  useEffect(() => {
    return () => { dispatch(clearAuthError()); };
  }, [dispatch]);

  const onSubmit = async (data) => {
    const result = await dispatch(forgotPassword(data.email));
    if (forgotPassword.fulfilled.match(result)) {
      navigate('/reset');
    }
  };

  return (
    <AuthPage title="Forgot password" error={error}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <EmailField register={register} errors={errors} />
        <div>
          <PrimaryButton
            type="submit"
            disabled={loading || !isDirty}
            className="flex w-full justify-center"
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </PrimaryButton>
        </div>
      </form>
      <p className="mt-10 text-center text-sm/6 text-gray-400">
        Remembered your password?{' '}
        <Link to="/login">Login</Link>
      </p>
    </AuthPage>
  );
}

export default Forgot;
